import { render, staticRenderFns } from "./Credenciamentos.vue?vue&type=template&id=6aa2e7b8"
import script from "./Credenciamentos.vue?vue&type=script&lang=js"
export * from "./Credenciamentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports